<template>
  <div>
    <div class="block">
      <!-- ID -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>ID</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex align-center">
          <div class="form-input-group w-248px">
            <input type="text" disabled />
          </div>
          <div class="h5 ink-02-medium--text ml-10px">(自動生成)</div>
        </div>
      </div>
      <!-- Subject -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Subject</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="form-input-group">
            <input type="text" />
          </div>
        </div>
      </div>
      <!-- Estimate Sends -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Estimate Sends</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <button class="btn">
            <v-icon class="mr-2">calculate</v-icon>
            <span>估算</span>
          </button>
        </div>
      </div>
      <!-- Area -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Area</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <SimpleSelectWithSearchInput
            buttonPlaceholder="請選擇Area"
            buttonWidth="248px"
            modalWidth="248px"
            modalBodyHeight="208px"
            :options="options.area"
            :selectedValue.sync="area"
          ></SimpleSelectWithSearchInput>
        </div>
      </div>
      <!-- 設定發送日期 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>設定發送日期</h4>
          <div class="mt-3 h5 ink-02-medium--text">將依設定日期開始發送</div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="請選擇年份"
            buttonWidth="148px"
            modalWidth="148px"
            modalBodyHeight="208px"
            :options="options.year"
            :selectedValue.sync="yearOfSend"
          >
          </SimpleSelectWithSearchInput>
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="請選擇月份"
            buttonWidth="148px"
            modalWidth="148px"
            modalBodyHeight="208px"
            :options="options.month"
            :selectedValue.sync="monthOfSend"
          ></SimpleSelectWithSearchInput>
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="請選擇日期"
            buttonWidth="148px"
            modalWidth="148px"
            modalBodyHeight="208px"
            :options="options.date"
            :selectedValue.sync="dateOfSend"
          ></SimpleSelectWithSearchInput>
        </div>
      </div>
      <!-- Recipients Source -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5 flex-shrink-0">
          <h4>Recipients Source</h4>
        </div>
        <div class="flex-grow-1 flex-wrap d-flex">
          <div
            v-for="item in [
              'Member',
              'EDM subscriber',
              'Reseller',
              'IR Email Alerts',
            ]"
            :key="item"
            class="w-33 mb-2"
          >
            <v-checkbox v-model="recipientsSource" :value="item">
              <template v-slot:label>
                <div class="h5 ink-01-emphasis--text">
                  {{ item }}
                </div>
              </template>
            </v-checkbox>
          </div>
          <div
            v-for="item in ['Upload Send List']"
            :key="item"
            class="mb-2 d-flex"
          >
            <v-checkbox v-model="recipientsSource" :value="item">
              <template v-slot:label>
                <div class="h5 ink-01-emphasis--text">
                  {{ item }}
                </div>
              </template>
            </v-checkbox>
            <div class="d-flex">
              <div
                v-if="uploadSendList[0]"
                class="h5 ml-2 primary--text"
                style="padding-top: 6px"
              >
                {{ fileName }}
              </div>
              <label class="btn h-28px w-128px ml-2" style="cursor: pointer;">
                <span>Choose xls file</span>
                <input
                  type="file"
                  style="width: 0; opacity: 0;"
                  ref="xlsFileInput"
                  @change="previewFile"
                />
              </label>
              <button
                v-if="uploadSendList[0]"
                class="btn h-28px w-128px ml-2 btn-outlined danger-01-emphasis--text"
                style="border-color: #f30000"
                @click="resetFileInput"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Recipients Filter -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Recipients Filter</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <h4 class="mb-5">收件者生日</h4>
          <div class="d-flex mb-5">
            <SimpleSelectWithSearchInput
              class="mr-5"
              buttonPlaceholder="請選擇年份"
              buttonWidth="148px"
              modalWidth="148px"
              modalBodyHeight="208px"
              :options="options.year"
              :selectedValue.sync="yearOfBirtyday"
            >
            </SimpleSelectWithSearchInput>
            <SimpleSelectWithSearchInput
              class="mr-5"
              buttonPlaceholder="請選擇月份"
              buttonWidth="148px"
              modalWidth="148px"
              modalBodyHeight="208px"
              :options="options.month"
              :selectedValue.sync="monthOfBirtyday"
            ></SimpleSelectWithSearchInput>
            <SimpleSelectWithSearchInput
              class="mr-5"
              buttonPlaceholder="請選擇日期"
              buttonWidth="148px"
              modalWidth="148px"
              modalBodyHeight="208px"
              :options="options.date"
              :selectedValue.sync="dateOfBirtyday"
            ></SimpleSelectWithSearchInput>
          </div>
          <h4 class="mb-5">產品註冊紀錄</h4>
          <div class="d-flex">
            <SimpleSelectWithSearchInput
              class="mr-5"
              buttonPlaceholder="請選擇產品"
              buttonWidth="148px"
              modalWidth="148px"
              modalBodyHeight="208px"
              :options="options.product"
              :selectedValue.sync="productOfRegistered"
            >
            </SimpleSelectWithSearchInput>
          </div>
        </div>
      </div>
      <!-- Recipients Language/Country -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5 flex-shrink-0">
          <h4>Recipients Language/Country</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <h4 class="mb-5">選擇語系 (關聯國家數)</h4>
          <div class="d-flex mb-5 flex-wrap">
            <button
              class="btn  w-150px mr-5 mb-5"
              :class="{
                'btn-outlined': recipientsLangageCountry !== item.name,
                'btn-primary': recipientsLangageCountry === item.name,
              }"
              style="position: relative;"
              v-for="item in options.languages"
              :key="`lang-${item.name}`"
              @click="recipientsLangageCountry = item.name"
            >
              <v-icon
                v-if="recipientsLangageCountry === item.name"
                color="white"
                :style="{ position: 'absolute', left: '14px' }"
              >
                check_circle
              </v-icon>
              <span>{{ item.name }} ({{ item.numOfRelatedCountries }})</span>
            </button>
          </div>
          <h4 class="mb-5">選擇國家</h4>
          <div class="mb-5" v-if="areas">
            <!-- items -->
            <PageCollapse v-for="area in areas" :key="`area-${area}`">
              <template v-slot:head>
                <h3 class="mr-auto">{{ area }}</h3>
              </template>
              <template v-slot:actions>
                <div class="ml-auto">
                  <v-checkbox v-model="selectedAreas" :value="area">
                    <template v-slot:label>
                      <div class="h5 ink-01-emphasis--text">全選</div>
                    </template>
                  </v-checkbox>
                </div>
              </template>
              <template v-slot:body>
                <div class="pt-5"></div>
                <button
                  class="btn w-150px mr-5 mb-5"
                  :class="{
                    'btn-outlined': recipientsLangageCountry !== item.name,
                    'btn-primary': recipientsLangageCountry === item.name,
                  }"
                  style="position: relative;"
                  v-for="item in options.countries.filter(
                    (i) => i.area === area,
                  )"
                  :key="`lang-${item.name}`"
                  @click="recipientsLangageCountry = item.name"
                >
                  <v-icon
                    v-if="recipientsLangageCountry === item.name"
                    color="white"
                    :style="{ position: 'absolute', left: '14px' }"
                  >
                    check_circle
                  </v-icon>
                  <span>{{ item.name }}</span>
                </button>
              </template>
            </PageCollapse>
          </div>
        </div>
      </div>
    </div>

    <!-- Block2 -->
    <div class="block mt-5" style="margin-bottom: 30px;">
      <PageMenu :sections="sections" menuHeadTitle="Content">
        <component :is="sectionView"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import PageCollapse from '@/components/PageCollapse.vue';
// block2
import PageMenu from '@/components/PageMenu.vue';
import KeyVisual from '@/views/K__eNewsletterEDMlist/c/KeyVisual.vue';
import Video from '@/views/K__eNewsletterEDMlist/c/Video.vue';
import SquareTiles from '@/views/K__eNewsletterEDMlist/c/SquareTiles.vue';
import ProductCards from '@/views/K__eNewsletterEDMlist/c/ProductCards.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
    PageCollapse,
    // block2
    PageMenu,
    KeyVisual,
    Video,
    SquareTiles,
    ProductCards,
  },
  data: () => ({
    area: '',
    yearOfSend: '',
    monthOfSend: '',
    dateOfSend: '',
    recipientsSource: [],
    uploadSendList: '',
    productOfRegistered: '',
    yearOfBirtyday: '',
    monthOfBirtyday: '',
    dateOfBirtyday: '',
    recipientsLangageCountry: '',
    selectedAreas: [],
    selectedCountries: [],
    options: {
      area: ['Taiwan', 'United States'],
      year: [...Array(100).keys()].map((i) => `${i + 1991}`),
      month: [...Array(12).keys()].map((i) => `${i + 1} `),
      date: [...Array(31).keys()].map((i) => `${i + 1} `),
      recipientsSource: [
        'Member',
        'EDM subscriber',
        'Reseller',
        'IR Email Alerts',
        'Upload Send List',
      ],
      product: ['product1', 'product2'],
      languages: [
        { name: '繁中', numOfRelatedCountries: 1 },
        { name: '英文 Global', numOfRelatedCountries: 99 },
        { name: '英文 US', numOfRelatedCountries: 1 },
        { name: '簡中', numOfRelatedCountries: 1 },
        { name: '巴葡', numOfRelatedCountries: 1 },
        { name: '義大利文', numOfRelatedCountries: 99 },
        { name: '法文', numOfRelatedCountries: 3 },
        { name: '荷蘭文', numOfRelatedCountries: 1 },
        { name: '韓文', numOfRelatedCountries: 2 },
      ],
      countries: [
        { name: '美國', area: 'America' },
        { name: '台灣', area: 'Asia' },
        { name: '香港', area: 'Asia' },
        { name: '中國', area: 'Asia' },
        { name: '英國', area: 'Europe' },
        { name: '伊朗', area: 'Asia' },
        { name: '伊拉克', area: 'Asia' },
        { name: '匈牙利', area: 'Europe' },
        { name: '國家名', area: 'America' },
      ],
    },
    sections: [
      {
        name: 'Key Visual',
        component: 'KeyVisual',
      },
      {
        name: 'Video',
        component: 'Video',
      },
      {
        name: '2 Square Tiles',
        component: 'SquareTiles',
      },
      {
        name: '3 Product Cards',
        component: 'ProductCards',
      },
    ],
  }),
  computed: {
    areas() {
      const areaArray = Object.values(
        this.options.countries.map((i) => i.area),
      );
      const noRepeatArea = [...new Set(areaArray)];
      return noRepeatArea;
    },
    fileName() {
      if (this.uploadSendList[0].name.length < 14) {
        return this.uploadSendList[0].name;
      }
      const strLength = this.uploadSendList[0].name.length;
      const frontChars = this.uploadSendList[0].name.substring(0, 6);
      const backChars = this.uploadSendList[0].name.substring(
        strLength - 7,
        strLength - 1,
      );
      return `${frontChars}...${backChars}`;
    },
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  methods: {
    previewFile(event) {
      this.$set(this, 'uploadSendList', event.target.files);
    },
    resetFileInput() {
      const input = this.$refs.xlsFileInput[0];
      input.type = 'text';
      input.type = 'file';
      this.uploadSendList = input.files;
    },
  },
};
</script>

<style></style>
